// NotoSansKr
export const NotoSansKrBlack = require("./NotoSansKR-Black.otf")
export const NotoSansKrBold = require("./NotoSansKR-Bold.otf");
export const NotoSansKrLight = require("./NotoSansKR-Light.otf");
export const NotoSansKrMedium = require("./NotoSansKR-Medium.otf");
export const NotoSansKrRegular = require("./NotoSansKR-Regular.otf");
export const NotoSansKrThin = require("./NotoSansKR-Thin.otf");